import "react-datetime/css/react-datetime.css";
import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import moment from "moment/moment";

const EducationFormPreview = ({ candidateCourse }) => {
  const { t } = useTranslation();

  return (
    <section className="form-group">
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="course">{t("Course")}</label>
        </div>
        <input
          value={t(candidateCourse.course ?? candidateCourse.otherCourse)}
          disabled
          className="custom-input"
        />
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="institution">{t("Institution")}</label>
        </div>
        <input
          className="custom-input"
          value={t(candidateCourse.school ?? candidateCourse.otherSchool)}
          disabled
        />
      </div>
      <div className="training-date">
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="startDate">{t("Start Year")}</label>
          </div>
          <div>
            <input
              type="number"
              name="startDate"
              placeholder="yyyy"
              value={
                candidateCourse.startDate
                  ? moment(candidateCourse.startDate).format("YYYY")
                  : ""
              }
              disabled
            />
          </div>
        </div>
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="endDate">{t("End Year")}</label>
          </div>
          <div>
            <input
              type="number"
              placeholder="yyyy"
              name="endDate"
              value={
                candidateCourse.endDate &&
                moment(candidateCourse.endDate).format("YYYY")
              }
              disabled
            />
          </div>
        </div>
        <div className="ongoing">
          <div className="label-wrapper">
            <label htmlFor="onGoing">{t("Ongoing")}</label>
          </div>
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="onGoing"
              name="onGoing"
              checked={candidateCourse.isOngoing}
              disabled
            />
          </div>
        </div>
        <div className="isCertification">
          <div className="label-wrapper">
            <label htmlFor="isCertification">{t("Is Certification")}?</label>
          </div>
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="isCertification"
              name="isCertification"
              defaultChecked={candidateCourse.isCertification}
              disabled
            />
          </div>
        </div>
        <div className="form-group">
          <div className="label-wrapper">
            <label htmlFor="finalClassification">
              {t("Final Classification")}
            </label>
          </div>
          <input
            className="custom-input"
            type="number"
            id="finalClassification"
            name="finalClassification"
            value={candidateCourse.finalClassification}
            disabled
          />
        </div>
      </div>
    </section>
  );
};

export default EducationFormPreview;
